import CourseScreen from './containers/courseScreen'

export {default as CourseScreenLayout} from './components/courseScreenLayout'

export default CourseScreen
